import { httpClient } from '@/httpClient';
import config from '@/config';
import { localeStore } from '@/locale';

const getCalculatedPriceRu = (params) => httpClient.get('/orders/calculate_price', { params });

/**
 * @param {{ tariff_id: string | number; count: number; promocode?: string; email?: string }} params
 * @param {object} options
 * @returns {Promise<{ data: { items: Record<string, number>, sum: string } }>}
 */
const getCalculatedPriceEn = (params, options = {}) => httpClient.get('/forms/orders/calculate_price', { ...options, params });
const createVisitor = async (payload) => httpClient.post('/visitors', payload, { skipErrorRedirect: true });

const createOrder = async (fd) => httpClient.post('/forms/orders', fd);

const createOrderWithoutPlans = async (fd) => httpClient.post('/forms/contact', fd, { skipErrorRedirect: true });

const askQuestion = async (fd) => httpClient.post('/forms/question', fd, { skipErrorRedirect: true });
const askQuestionEn = async (fd) => httpClient.post('/forms/contact', fd, { skipErrorRedirect: true });

const createOrderModal = async (fd) => httpClient.post('/orders', fd, { skipErrorRedirect: true });
const getOrderPaymentStatus = (url) => {
  const statusUrl = new URL(url);
  const apiUrl = new URL(config.apiURL[localeStore.lang]);
  if (statusUrl.origin !== apiUrl.origin || !/\/orders\/\d+\/payment-status$/.test(statusUrl.pathname)) {
    throw new Error('Invalid payment status URL');
  }
  return httpClient.get(url, { skipErrorRedirect: true });
};
const getConfirmationToken = async (fd) => httpClient.post('/orders', fd);

const demoOrder = async (fd) => httpClient.post('/forms/demo', fd, { skipErrorRedirect: true });

const getAuthUserData = async () => httpClient.get('/account');

const refreshToken = async () => httpClient.post('/auth/refresh');

const sendContact = async (fd) => httpClient.post('/forms/contact', fd, { skipErrorRedirect: true });

export const api = {
  createOrder,
  createVisitor,
  createOrderWithoutPlans,
  getCalculatedPriceRu,
  getCalculatedPriceEn,
  askQuestion,
  createOrderModal,
  getOrderPaymentStatus,
  getConfirmationToken,
  demoOrder,
  getAuthUserData,
  refreshToken,
  sendContact,
  askQuestionEn,
};
